import { shouldHideAnnotation } from './shouldHideAnnotation.js';

function isShowMoreAnnotationsButtonVisible(rowCount) {
  return shouldHideAnnotation({
    row: 3,
    isShowingAllAnnotations: false,
    rowCount
  });
}

export { isShowMoreAnnotationsButtonVisible };
